// extracted by mini-css-extract-plugin
module.exports = {"label":"Label__label___1NGWg","hideOnSmallScreens":"Label__hideOnSmallScreens___23ye5"};